module.exports = __webpack_public_path__ + "static/img/press1.95e7452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press1.png
// module id = lu3m
// module chunks = 0